var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 42.856,
    viewBox: "0 0 50 42.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-188.886 -415.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M213.889,458.765q-9.65,0-19.3,0a5.368,5.368,0,0,1-5.693-5.7c0-8.09-.035-16.179.032-24.268a24.619,24.619,0,0,1,.69-4.222c.337-1.807.718-3.606,1.061-5.412a3.625,3.625,0,0,1,3.913-3.257h38.6a3.625,3.625,0,0,1,3.911,3.26c.557,2.9,1.138,5.795,1.7,8.694a4.684,4.684,0,0,1,.079.885q.006,12.19,0,24.38a5.358,5.358,0,0,1-5.64,5.636Q223.567,458.768,213.889,458.765Zm-21.423-28.558v.585q0,11.159,0,22.317a1.836,1.836,0,0,0,2.089,2.084h38.659c1.434,0,2.1-.675,2.1-2.128q0-11.131,0-22.261v-.6Zm.393-3.607h42.063l-1.4-7.093H194.253Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M316.118,455.487c-1.729,0-3.458,0-5.187,0a1.793,1.793,0,1,1,.023-3.569q5.159,0,10.319,0a1.8,1.8,0,1,1-.023,3.569Q318.684,455.49,316.118,455.487Z",
    transform: "translate(-102.226 -30.649)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.cb9abaa6826b5aaf68f6f6bc377d5a45.svg";
export { ForwardRef as ReactComponent };